// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Hpq2k","label":"styles_label__3_zGf"};